import { render, staticRenderFns } from "./TitleBlock.vue?vue&type=template&id=4c8cde2a&scoped=true&"
import script from "./TitleBlock.vue?vue&type=script&lang=js&"
export * from "./TitleBlock.vue?vue&type=script&lang=js&"
import style0 from "./TitleBlock.vue?vue&type=style&index=0&id=4c8cde2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cde2a",
  null
  
)

export default component.exports